import styled from 'styled-components';
import {alignCenter, dFlex, dFlexEnd, flexWrap, justifyCenter} from '../../../../../globalVariables/GlobalFlex';

export const metaRowWrap = styled.div`
    ${dFlex};
    ${flexWrap};
    ${alignCenter};
    ${justifyCenter};
    gap: var(--space-lg) var(--space-3xl);
    width: 100%;
`;

export const metaChunk = styled.div`
    ${dFlexEnd};
    gap: var(--space-sm);
`;

export const metaText = styled.span`
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-body);
    color: var(--color-text-default);
`;
